import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { changeField, changeStatus, changeType, displayLabel } from "../../constants/labels";
import { OssDataGridFrame } from "../common/OssDataGridFrame";

const statusMeta = {
  REQUESTED: { color: "warning" },
  REVIEWING: { color: "info" },
  APPROVED: { color: "success" },
  APPLIED: { color: "success" },
  REJECTED: { color: "error" },
  CANCELLED: { color: "default" },
};

export const OssChangeList = ({ rows = [], loading, onReview, height = 520 }) => (
  <OssDataGridFrame height={height}>
    <DataGrid
      disableRowSelectionOnClick
      loading={loading}
      rows={Array.isArray(rows) ? rows : []}
      getRowId={(row) => row?.change_request_id}
      rowHeight={56}
      columnHeaderHeight={44}
      columns={[
      { field: "order_no", headerName: "주문번호", flex: 0.9, headerAlign: "center", align: "center" },
      { field: "customer_name", headerName: "거래처", flex: 0.8, headerAlign: "center", align: "center" },
      { field: "item_name_snapshot", headerName: "품목", flex: 1.1, headerAlign: "center" },
      {
        field: "change_type",
        headerName: "유형",
        flex: 0.7,
        headerAlign: "center",
        align: "center",
        renderCell: ({ value }) => displayLabel(changeType, value),
      },
      {
        field: "details",
        headerName: "변경 내용",
        flex: 1.6,
        sortable: false,
        renderCell: ({ row }) => (
          <Stack spacing={0.2} justifyContent="center" sx={{ width: "100%", height: "100%", overflow: "hidden" }}>
            {(row.details || []).slice(0, 2).map((detail) => (
              <Typography key={detail.field_name} noWrap sx={{ fontSize: 12.5, color: "#374151" }}>
                {displayLabel(changeField, detail.field_name)}: {detail.before_value || "-"} 에서 {detail.after_value || "-"}로 변경
              </Typography>
            ))}
          </Stack>
        ),
      },
      {
        field: "request_status",
        headerName: "상태",
        flex: 0.7,
        headerAlign: "center",
        align: "center",
        renderCell: ({ value }) => {
          const meta = statusMeta[value] || { color: "default" };
          return <Chip size="small" label={displayLabel(changeStatus, value)} color={meta.color} variant="outlined" />;
        },
      },
      { field: "requested_at", headerName: "요청일시", flex: 1, headerAlign: "center", align: "center" },
      {
        field: "actions",
        headerName: "처리",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: ({ row }) => {
          const disabled = !["REQUESTED", "REVIEWING"].includes(row.request_status);
          return (
            <Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 0.6 }}>
              <Button size="small" variant="contained" startIcon={<CheckRoundedIcon />} disabled={disabled} onClick={() => onReview(row, "APPROVED")}>
                승인
              </Button>
              <Button size="small" variant="outlined" color="error" startIcon={<CloseRoundedIcon />} disabled={disabled} onClick={() => onReview(row, "REJECTED")}>
                반려
              </Button>
            </Box>
          );
        },
      },
      ]}
      hideFooter={(Array.isArray(rows) ? rows.length : 0) <= 10}
      sx={{
        "& .MuiDataGrid-columnHeaderTitle": { fontSize: 12.5, fontWeight: 800, color: "#374151" },
        "& .MuiDataGrid-cell": { display: "flex", alignItems: "center", py: 0.75, color: "#374151" },
        "& .MuiDataGrid-row:hover": { bgcolor: "#fbfbfe" },
      }}
    />
  </OssDataGridFrame>
);
